import React from 'react'
import NavLink from '../common/NavLink'
import { connect } from 'react-redux'

class ManagerMenuItems extends React.Component {
  render() {
    return (
      <div className="vertical-menu">
        <NavLink to="/dashboard">
          <i className="fa fa-th-large" aria-hidden="true" />
          <span>داشبورد</span>
        </NavLink>

        <NavLink to="/dashboard/manager-students">
          <i className="fa fa-users" aria-hidden="true" title="مدیریت دانش آموزان" />
          <span>مدیریت دانش آموزان</span>
        </NavLink>

        {/* <NavLink to="/dashboard/manager-teachers">
          <i className="fa fa-user" aria-hidden="true" title="مدیریت معلمان" />
          <span>مدیریت معلمان</span>
        </NavLink> */}

        <NavLink to="/dashboard/manager-schools">
          <i className="fa fa-graduation-cap" aria-hidden="true" title="مدیریت مدارس" />
          <span>مدیریت مدارس</span>
        </NavLink>

        <NavLink to="/dashboard/manager-supervisors">
          <i className="fa fa-eye" aria-hidden="true" title="مدیریت نماینده‌ها" />
          <span>مدیریت نماینده‌ها</span>
        </NavLink>

        {/* <NavLink to="/dashboard/manager-apps">
          <i className="fa fa-laptop" aria-hidden="true" title="مدیریت نرم افزار ها" />
          <span>مدیریت نرم افزار ها</span>
        </NavLink> */}

        <NavLink to="/dashboard/products">
          <i className="fa fa-book" aria-hidden="true" title="مدیریت محصولات" />
          <span>مدیریت محصولات</span>
        </NavLink>

        {/* <NavLink to="/dashboard/online-tests">
          <i
            className="fa fa-check-square-o"
            aria-hidden="true"
            title="آزمون های آنلاین"
          />
          <span>آزمون های آنلاین</span>
        </NavLink> */}

        <NavLink to="/dashboard/events">
          <i className="fa fa-calendar" aria-hidden="true" title="رویداد ها" />
          <span>رویداد ها</span>
        </NavLink>

        {/*
          <NavLink to="/dashboard/messages">
          <i className="fa fa-envelope" aria-hidden="true" />
          <span>مدیریت پیام ها</span>
          </NavLink>
        */}
      </div>
    )
  }
}

// just to force this component to re-render when routes change
// otherwise it won't re-render
const mapStateToProps = state => state.routing.locationBeforeTransitions

export default connect(mapStateToProps)(ManagerMenuItems)



// WEBPACK FOOTER //
// ./src/components/manager/ManagerMenuItems.js